module.exports = __webpack_public_path__ + "static/media/08-01.77051534.png";